import React from 'react';
import { Info, PlayCircle, CheckCircle2, Check } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

export const EditorStepper = ({ step, onStep, canAdvance }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const steps = [
    { key: 'basic', Icon: Info, label: L('المعلومات الأساسية', 'Basic info') },
    { key: 'content', Icon: PlayCircle, label: L('المحتوى والدروس', 'Content & lessons') },
    { key: 'review', Icon: CheckCircle2, label: L('مراجعة ونشر', 'Review & publish') },
  ];
  const idx = steps.findIndex(s => s.key === step);
  return (
    <nav data-testid="course-editor-stepper" className="grid grid-cols-3 rounded-2xl bg-white border border-slate-200 p-1.5 mb-6 shadow-sm">
      {steps.map((s, i) => {
        const active = s.key === step;
        const done = i < idx;
        const disabled = i > 0 && !canAdvance;
        return (
          <button key={s.key} type="button" disabled={disabled} onClick={() => onStep(s.key)} data-testid={`course-step-${s.key}`}
            className={`flex items-center justify-center gap-2 h-11 sm:h-12 rounded-xl text-xs sm:text-sm font-bold transition-[background-color,color] disabled:opacity-40 disabled:cursor-not-allowed ${active ? 'bg-blue-50 text-blue-700 ring-2 ring-blue-500' : 'text-slate-500 hover:bg-slate-50'}`}>
            <span className={`w-7 h-7 rounded-full flex items-center justify-center ${done ? 'bg-emerald-500 text-white' : active ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}>
              {done ? <Check className="w-4 h-4" /> : <s.Icon className="w-4 h-4" />}
            </span>
            <span className="hidden sm:inline">{s.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
